import { request } from '@/shared/api/request'
export const refreshConsentAndPhone = (externalId) => {
	return request({
		url: `/proactive/refreshConsentAndPhone/${externalId}`,
		method: 'POST',
	})
}